import { useState } from 'react';
import LabMeasurementReaderResult from './LabMeasurementReaderResult';
import PiAfEventReaderQuery from './PiAfEventReaderQuery';

function PiAfEventReaderComponent(props) {
	const piAfEventReaderName = props.piAfEventReaderName || null;
	const [result, setResult] = useState(null);

	return (
		<div>
			<PiAfEventReaderQuery
				onResult={nextResult => setResult(nextResult)}
				piAfEventReaderName={piAfEventReaderName}
			/>
			{result != null && (
				<LabMeasurementReaderResult
					result={result}
					onLoad={values => props.onLoad(values)}
				/>
			)}
		</div>
	);
}

export default PiAfEventReaderComponent;
